<template>
 <div class="row justify-content-center">

    <div id="loaderoverlay" v-bind:style={display:onloader}>
        <div class="w-100 d-flex justify-content-center align-items-center">
            <div class="loaderspinner"></div>
        </div>
    </div>
    <div class="col-lg-5 col-md-7">
        <div class="card bg-secondary shadow border-0">
            <div class="card-body px-lg-5 py-lg-5">
                <div class="text-center text-muted my-3">
                    
                    <p class="mt-3">Enter below details to change your password</p>
                </div><hr/>
                <form role="form" @submit.prevent="submitdetails">
                    <base-input class="input-group-alternative mb-3" placeholder="Username" addon-left-icon="ni ni ni-single-02" v-model="username">
                    </base-input>

                    <div class="text-center">
                        <button type="submit" class="my-4 btn btn-primary btn-block">Submit</button>
                    </div>
                </form>
                <div class="text-center pt-2">
                    <router-link to="/login" class="text-primary"><small>Back to Login</small></router-link>
                </div>                     
            </div>
        </div>
    </div>
</div>
</template>

<script>
import swal from 'sweetalert'

export default {
    name: 'Retrievepassword',
    data() {
        return {
            username: '',
            errormsg: '',
            onloader: 'none'
        }
    },
    
    methods: {
        submitdetails: function () {
            let username = this.username;
            let accesskey = this.$store.state.auth.accesskey;

            this.onloader = 'flex'
            this.$store.dispatch('resetpassword', {
                    username,
                    accesskey
                })
                .then(() => {
                    this.onloader = 'none'
                    swal({
                        title: "Success!",
                        text: "Your password has been reset successfully, check phone message and email for new password",
                        icon: "success",
                        button: "Ok",
                    });
                })
                .catch(err => {
                    this.onloader = 'none'
                    swal({
                        title: "Oops!",
                        text: err.response.data,
                        icon: "error",
                        button: "Ok",
                    });
                })
        }
    }
}
</script>

<style>
</style>
